import React, {Component} from 'react';
import {connect} from 'react-redux';
import '../../style/common-style.css';
import '../../style/my-dashBoard.css';
import '../../style/font-family.css';
import '../../style/top-menubar.css';
import * as Constants from '../common/Constants';
import AuthService from '../../services/AuthService';
import ProfileService from '../../services/ProfileService';
import HOCLogger from '../common/HOCLogger';
import {withRouter} from "react-router-dom";
import Error from '../error/Error';
import * as Tagging from '../../tagging/LoginFormTagging';
import ContactService from "../../services/ContactService";

class LoginChild extends Component {

    constructor(props) {
        super(props)
        this.state = {
            username: '',
            password: '',
            passDisplayValue:'',
            loginsuccess: false,
            isValidUsername: false,
            isValidPassword: false,
            displayPage: Constants.LOGIN,
            rememberme: false,
            showPassword: false,
            usernameActive: false,
            inputpasswordActive: false,
        }
        this.changeDisplay = this.changeDisplay.bind(this);
        this.showCloseBtn();
        Tagging.loginPageLoad();
    }

    componentDidMount() {
        var username = "";
        var loginUserCookie = document.cookie.toString();
        if (loginUserCookie.indexOf("loginCookie=") > -1 && loginUserCookie.indexOf(";") > -1) {
            var tempUsername = loginUserCookie.substring(loginUserCookie.indexOf("loginCookie=") + 12);
            if (tempUsername.indexOf(";") === -1) {
                username = tempUsername;
            } else {
                username = tempUsername.substring(0, tempUsername.indexOf(";"));
            }
        } else if (loginUserCookie.indexOf("loginCookie=") > -1) {
            username = loginUserCookie.substring(loginUserCookie.indexOf("loginCookie=") + 12, loginUserCookie.length);
        }
        if (username) {
            this.setState({
                ...this.state,
                username: username,
                usernameActive: (username !== ''),
                rememberme: (username !== '')
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevState.password === '' && this.state.password !=='') {
            this.setState({inputpasswordActive: true})
        }
    }

    showCloseBtn = () => {
        this.props.showCloseBtn(true);
    }

    callForgotUsername = () => {
        this.props.setPageToBeDisplayed(Constants.FORGET_USERNAME);
    };
    callForgotPassword = () => {
        this.props.setPageToBeDisplayed(Constants.FORGET_PASSWORD);
    };

    callOnSubmit = (e) => {
        e.preventDefault();
        this.props.setPassword(this.state.password);
        Tagging.loginClickEvent(this.state.username);
        this.setState({
            ...this.state,
        });
        this.props.setContextDetails({});
        localStorage.setItem("_masterAccount", "");
        this.props.showLoader(true);
        AuthService.authenticateUser(this.state.username, this.state.password.toString()).then((res) => {
            this.setState({
                ...this.state,
                loginsuccess: res.data.result.result
            });
            if (res.data.result.result === true) {
                if (res.data.result.redirect === 'dashboard') {
                    ContactService.getContextUserInformation(this.state.username)
                        .then((response) => {
                            if (response.status === 200) {
                                const data = {
                                    "userName": response.data.result.userName,
                                    "email": response.data.result.email,
                                    "cellNumber": response.data.result.cellNumber,
                                    "contactID": response.data.result.contactID,
                                    "firstName": response.data.result.firstName,
                                    "lastName": response.data.result.lastName,
                                    "msLoginUrl": response.data.result.redirect
                                };

                                this.props.setContextDetails(data);

                                ProfileService.getGsmAccessStatus(data.contactID)
                                    .then((response) => {

                                        this.props.setGSMAccess(response.data.result);
                                        if (response.data.result) {
                                            Constants.redirectToDashboard();
                                        } else {
                                            Constants.redirectToFixProducts();
                                        }
                                    }).catch((error) => {
                                    this.props.setGSMAccess(false);
                                    this.setState({
                                        ...this.state
                                    });
                                    Constants.redirectToFixProducts();
                                })
                            }
                        }).catch((error) => {
                            this.props.showLoader(false);
                            this.setState({
                                ...this.state,
                                displayPage: Constants.ERROR,
                                isLoading: false
                            });

                            this.props.setContextDetails({});
                            this.props.setErrorDetails("We are experiencing technical difficulties.", "Please try again later.", Constants.LOGIN);
                    });
                } else {
                     ProfileService.generateOTP(this.state.username)
                    .then((response) => {
                        if (response.status === 200) {
                            this.props.onLoginSuccess(this.state.username);
                            if (response.data.result.message) {
                                this.props.setMsisdnNumber(response.data.result.message.substring((response.data.result.message.indexOf(":") + 1), response.data.result.message.length));
                                this.setState({
                                    ...this.state,
                                    isLoading: false
                                });
                                this.props.showLoader(false);
                            }
                            this.props.setPageToBeDisplayed(Constants.LOGINOTP);
                        }
                    }).catch((err) => {
                        this.setState({
                            ...this.state,
                            isLoading: false
                        });
                        Constants.removeCookie(Constants.AUTH_TOKEN);
                        this.props.showLoader(false);
                        if (err && err.response && err.response.data && err.response.data.messages) {
                            if (err.response.data.messages[0].message === "You have entered the OTP incorrectly three times. For your security, you are temporarily blocked from requesting new OTPs. Please try again in 24 hours.") {
                                this.setState({
                                    ...this.state,
                                    displayPage: Constants.ERROR});
                                this.props.setErrorDetails("You have entered the OTP incorrectly three times. For your security, you are temporarily blocked from requesting new OTPs.","Please try again in 24 hours.",Constants.LOGIN);
                            } else {
                                    this.setState({
                                        ...this.state,
                                        displayPage: Constants.ERROR});
                                    this.props.setErrorDetails("We are unable to generate an OTP.", "Please try again later.", Constants.LOGIN);
                                }
                            }
                         });
                }
                if (this.state.rememberme === true) {
                    var d = new Date();
                    d.setTime(d.getTime() + (10 * 24 * 60 * 60 * 1000));
                    var expires = "expires=" + d.toUTCString();
                    document.cookie = "loginCookie=" + this.state.username + "; " + expires;
                } else {
                    document.cookie = "loginCookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
                }
            }
        }).catch((error) => {
            this.props.showLoader(false);
            this.setState({
                ...this.state,
                displayPage: Constants.ERROR
            })
            this.props.showLoader(false)
            if (error && error.response && error.response.data && error.response.data.messages && error.response.data.messages[0]) {
                if (error.response.data.messages[0].message.includes('Your details could not be verified. Please contact the System Administrator.')) {
                    this.props.setErrorDetails("The username or password you entered is incorrect.", "", Constants.LOGIN);
                    Tagging.loginErrorEvent("The username or password you entered is incorrect.");
                }
                else {
                    this.props.setErrorDetails("We are experiencing technical difficulties.", "Please try again later.", Constants.LOGIN);
                    Tagging.loginErrorEvent("We are experiencing technical difficulties.Please try again later.");
                }

            }
            else {
                this.setState({
                    ...this.state,
                    displayPage: Constants.ERROR
                });
                this.props.setErrorDetails("We are experiencing technical difficulties.", "Please try again later.", Constants.LOGIN);
                Tagging.loginErrorEvent("We are experiencing technical difficulties.Please try again later.");
            }

        });
    };

    changeDisplay() {
        this.props.callFromChildPage(false);
        Tagging.loginPageLoad();
        this.setState({
            displayPage: Constants.LOGIN
        });
        if(window.location.search !== null && window.location.search !== undefined){
            var urlParams = new URLSearchParams(window.location.search);
            if(urlParams.has('error') && urlParams.get('error') === "true"){
                const url = window.location.toString();
                window.location.assign(url.substring(0,url.indexOf("?")));
            }
        }
    }

    showPassword = () => {
        this.setState(state => ({showPassword: !state.showPassword}))
    }

    activateField = (e) => {
        this.setState({
            [`${e.target.id}Active`]: true
        });
    };

    disableField = (e) => {
        if (e.target.value === "") {
            this.setState({
                [`${e.target.id}Active`]: false
            });
        }

    };

    encryptEnteredPassword =(value)=>{

        this.setState({
            ...this.state,
            passDisplayValue:value
        }, ()=>{
            if(this.state.passDisplayValue.length >= 3) {
                this.setState({
                    ...this.state,
                    password: Constants.encryptStr(this.state.passDisplayValue),
                    isValidPassword: true
                })
            }
            if(this.state.passDisplayValue.length <= 3) {
                this.setState({
                    ...this.state,
                    isValidPassword: false
                })
            }
        })
    }

    render() {
        return (
            <>
                <form className="login-form" onSubmit={this.callOnSubmit}>

                    {this.state.displayPage === Constants.LOGIN && !this.props.isError ?
                        <div>
                            <label className="form-title" automationid="LoginPage_Label_Msg_1">
                                Log in to your account
                    </label>
                            <p className="sub-url" automationid="LoginPage_P_DontHaveAccount_1">
                                Don’t have an account yet?
                        <span onClick={() => this.props.setPageToBeDisplayed(Constants.REGISTER)} automationid="LoginPage_Span_RegisterNow_1">&nbsp;Register now</span>
                            </p>
                            <div className="input-field">
                                <label className={this.state.usernameActive || this.state.username.length ? "labelAnimate" : ""} automationid="LoginPage_Label_Username_1">Username</label>
                                <input
                                    automationid="LoginPage_Input_Username_1"
                                    type="text"
                                    id="username"
                                    className="form-input"
                                    placeholder=""
                                    value={this.state.username}
                                    onFocus={this.activateField}
                                    onBlur={this.disableField}
                                    onChange={e => {
                                        if (e.target.value.length >= 3) {
                                            this.setState({
                                                ...this.state,
                                                username: e.target.value,
                                                isValidUsername: true
                                            })
                                        } else {
                                            this.setState({
                                                ...this.state,
                                                username: e.target.value,
                                                isValidUsername: false
                                            })
                                        }
                                    }}
                                />
                            </div>
                            <div className="input-field">
                                <label className={this.state.inputpasswordActive || this.state.passDisplayValue.length ? "labelAnimate" : ""} automationid="LoginPage_Label_Password_1">Password</label>
                                <div className="password-row"><input
                                    automationid="LoginPage_Input_Password_1"
                                    type={this.state.showPassword ? "text" : "password"}
                                    className="form-input"
                                    placeholder=""
                                    value={this.state.passDisplayValue}
                                    id="inputpassword"
                                    onFocus={this.activateField}
                                    onBlur={this.disableField}
                                    onChange={e => {
                                            this.encryptEnteredPassword(e.target.value);
                                    }}
                                />
                                    <span className="show-password" onClick={this.showPassword} automationid="LoginPage_Span_Show_1">{this.state.showPassword ? "Hide" : "Show"}</span>
                                </div>
                            </div>

                            <p className="login-RememberMe">
                                <label className={this.state.rememberme && "active"}>
                                    <input automationid="LoginPage_Input_RememberMe_1" type="checkbox" className="rememberme" id="acceptTC" checked={!!this.state.rememberme} onChange={
                                        (e) => {
                                            this.setState({
                                                ...this.state,
                                                rememberme: e.target.checked
                                            })

                                        }
                                    } />
                                    <svg focusable="false" aria-hidden="true" className="icon" automationid="LoginPage_Svg_RememberMe_3">
                                        <use xlink="http://www.w3.org/1999/xlink" href="#icon-tick"></use>
                                    </svg></label> <span automationid="LoginPage_Span_RememberMe_2">Remember me</span>
                            </p>
                            <div className="space200"></div>
                            <div className="bottom-section">
                                <input type="submit"  automationid="LoginPage_Input_Submit_1"
                                    className={(this.state.isValidUsername || this.state.username.length > 0) && this.state.isValidPassword ? "btn btn-red" : "btn btn-red disabled"}
                                    value="LOG IN" />
                                <p className="bottom-message"  automationid="LoginPage_P_Forgot_1">
                                    Forgot your <span className="url" automationid="LoginPage_P_ForgotUsername_2" onClick={this.callForgotUsername}>username</span> or
                            <span className="url" automationid="LoginPage_P_ForgotPassword_3" onClick={this.callForgotPassword}> password</span>?
                        </p>
                            </div>
                        </div> : null}
                    {
                        this.state.displayPage === Constants.ERROR || this.props.isError ?
                            <Error eTitle={'Sorry!'} changeDisplay={this.changeDisplay} />
                            : null
                    }
                </form>
            </>
        )
    }
}


const mapDispatchToProps = dispatch => {
    return {
        onLoginSuccess: (username) => dispatch({ type: Constants.LOGIN_SUCCESS, username: username }),

        setGSMAccess: (value) => dispatch({ type: Constants.SET_GSM_ACCESS, value: value }),
        setContextDetails: (response) => dispatch({
            type: Constants.SET_CONTEXT_DETAIL,
            payload: response
        }),
        setMsisdnNumber: (number) => dispatch({ type: Constants.OTP_MSISDN, otpmsisdn: number }),
        setPageToBeDisplayed: (pageToBeDisplayed) => dispatch({
            type: Constants.SET_PAGE_TOBE_DISPLAYED,
            payload: pageToBeDisplayed
        }),
        setErrorDetails: (errorMessage1, errorMessage2, errorFrom) => dispatch({
            type: Constants.SET_ERROR_DETAILS,
            payload: {
                errorMessage1: errorMessage1,
                errorMessage2: errorMessage2,
                errorFrom: errorFrom
            }
        })


    }
}

const mapStateToProps = state => {
    return {
        pageToBeDisplayed: state.pageToBeDisplayed,
        otpmsisdn: state.otpmsisdn
    }
};

export default withRouter(HOCLogger(connect(mapStateToProps, mapDispatchToProps)(LoginChild)));
